import { HttpTypes } from '@/types';
import { AxiosInstance } from 'axios';

class AgeRestriction {
  private readonly client: AxiosInstance;
  private routePath = '/sites';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async detail() {
    const response = await this.client.get(`${this.routePath}/age-restriction`);
    return response.data;
  }

  async upsert(
    data: HttpTypes.AdminAgeRestrictionPayload
  ): Promise<HttpTypes.IResponse<HttpTypes.AdminAgeRestrictionResponse>> {
    const result = await this.client.put(
      `${this.routePath}/update/preferences-age-restrictions`,
      data
    );
    return result.data;
  }
}

export default AgeRestriction;
